import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';

export const BaseDateTimePicker: FunctionComponent<
  DateTimePickerProps<Date, Date>
> = (
  props: PropsWithChildren<DateTimePickerProps<Date, Date>>
): ReactElement => {
  const { children, ...dateTimeFieldProps } = props;

  const baseDateTimePickerProps = {
    ampm: false,
    components: { OpenPickerIcon: ArrowDropDownIcon },
    ...dateTimeFieldProps,
  };

  return (
    <DateTimePicker {...baseDateTimePickerProps}>{children}</DateTimePicker>
  );
};
